var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGobeFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03905 13.1663C10.3373 13.1663 12.2018 11.3017 12.2018 8.99997C12.2018 6.69822 10.3373 4.83367 8.03905 4.83367C5.74078 4.83367 3.87627 6.69822 3.87627 8.99997C3.87627 11.3017 5.74078 13.1663 8.03905 13.1663ZM13.4486 8.99997C13.4486 11.9895 11.0267 14.413 8.03905 14.413C5.05145 14.413 2.62952 11.9895 2.62952 8.99997C2.62952 6.01042 5.05145 3.58691 8.03905 3.58691C11.0267 3.58691 13.4486 6.01042 13.4486 8.99997Z",
    fill: "#58B255"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7859 15.1694C14.1931 13.6524 15.7255 9.6605 14.2085 6.25323C12.6914 2.84597 8.69954 1.31362 5.29227 2.83063C1.88501 4.34764 0.352654 8.33956 1.86967 11.7468C3.38668 15.1541 7.37859 16.6864 10.7859 15.1694ZM15.3474 5.74613C17.1445 9.78243 15.3293 14.5113 11.293 16.3084C7.25666 18.1055 2.52778 16.2902 0.7307 12.2539C-1.06638 8.21762 0.748873 3.48874 4.78517 1.69166C8.82147 -0.105412 13.5504 1.70984 15.3474 5.74613Z",
    fill: "#AAAAAA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.3938,
    y: 17.9539,
    width: 1.24675,
    height: 1.87013,
    transform: "rotate(-156 4.3938 17.9539)",
    fill: "#AAAAAA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6844,
    y: 0.0461426,
    width: 1.24675,
    height: 1.87013,
    transform: "rotate(24 11.6844 0.0461426)",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGobeFavicon);
export default __webpack_public_path__ + "static/media/gobe-favicon.eb076bb7246f08d03063292dc62ddd93.svg";
export { ForwardRef as ReactComponent };